export default __webpack_public_path__ + "static/media/researchgate.a4852ae6.svg";